
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  position: relative;
  text-align: left;
}

.bar-graph-panel {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 9999px;
  background-color: var(--gray-professional-lighten-5);
  padding-left: 1.25rem;
}

@media (min-width: 1024px) {

  .bar-graph-panel {
    padding-left: 2.5rem;
  }
}

@media (min-width: 1280px) {

  .bar-graph-panel {
    padding-left: 4rem;
  }
}

.bar-graph-panel--text, .bar-graph-panel--number {
  margin: 0px;
}

.bar-graph-panel--text, .bar-graph-panel--number {
  display: contents;
}

.bar-graph-panel--text, .bar-graph-panel--number {
  height: 2.5rem;
}

.bar-graph-panel--text, .bar-graph-panel--number {
  font-weight: var(--fw-semibold);
}

.bar-graph-panel--text, .bar-graph-panel--number {
  text-transform: uppercase;
}

.bar-graph-panel--text, .bar-graph-panel--number {
  color: var(--gray-professional-darken-1);
}

.bar-graph-panel--number {
  color: var(--outline-white);
}

@media (min-width: 1024px) {

  .bar-graph-panel--number {
    color: var(--gray-professional-darken-1);
  }
}

.bar-graph-panel--number {
  display: none;
}

.bar-graph-panel:hover, .bar-graph-panel--active {
  cursor: pointer;
}

.bar-graph-panel:hover .bar-graph-panel--text, .bar-graph-panel--active .bar-graph-panel--text {
  display: none;
}

.bar-graph-panel:hover .bar-graph-panel--number, .bar-graph-panel--active .bar-graph-panel--number {
  display: contents;
}

.bar-graph-panel:hover .bar-graph-panel--bar, .bar-graph-panel--active .bar-graph-panel--bar {
  background-color: var(--blue-responsible-main) !important;
}

.bar-graph-panel--active:hover .bar-graph-panel--bar {
  background-color: var(--blue-responsible-lighten-1) !important;
}

.bar-graph-panel--text-container {
  display: flex;
}

.bar-graph-panel--text-container {
  align-items: center;
}

.bar-graph-panel--text-container {
  line-height: 1;
}

.bar-graph-panel--text-container, .bar-graph-panel--bar-container {
  position: relative;
}

.bar-graph-panel--text-container, .bar-graph-panel--bar-container {
  z-index: 10;
}

.bar-graph-panel--text-container, .bar-graph-panel--bar-container {
  height: 2.5rem;
}

.bar-graph-panel--text-container, .bar-graph-panel--bar-container {
  width: 100%;
}

@media (min-width: 1024px) {

  .bar-graph-panel--text-container, .bar-graph-panel--bar-container {
    width: 50%;
  }
}

.bar-graph-panel--bar-container {
  position: absolute;
}

.bar-graph-panel--bar-container {
  left: 0px;
}

.bar-graph-panel--bar-container {
  z-index: 0;
}

@media (min-width: 1024px) {

  .bar-graph-panel--bar-container {
    position: relative;
  }
}

.bar-graph-panel--bar {
  position: relative;
}

.bar-graph-panel--bar {
  z-index: 0;
}

.bar-graph-panel--bar {
  height: 100%;
}

.bar-graph-panel--bar {
  border-radius: 9999px;
}

.bar-graph-panel--bar {
  background-color: var(--gray-professional-lighten-2);
}

.bar-graph-panel--bar {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.bar-graph-panel--bar {
  transition-duration: 300ms;
}

.bar-graph-panel--item-1 .bar-graph-panel--bar{
    background:#b3d8ec;
  }

.bar-graph-panel--item-2 .bar-graph-panel--bar{
    background:#a8d4eb;
  }

.bar-graph-panel--item-3 .bar-graph-panel--bar{
    background:#9dcfea;
  }

.bar-graph-panel--item-4 .bar-graph-panel--bar{
    background:#93cbe9;
  }

.bar-graph-panel--item-5 .bar-graph-panel--bar{
    background:#87c6e7;
  }

.bar-graph-panel--item-6 .bar-graph-panel--bar{
    background:#7dc2e7;
  }

.bar-graph-panel--item-7 .bar-graph-panel--bar{
    background:#73bee6;
  }

.bar-graph-panel--item-8 .bar-graph-panel--bar{
    background:#68b9e5;
  }

.bar-graph-panel--item-9 .bar-graph-panel--bar{
    background:#5db5e4;
  }

.bar-graph-panel--item-10 .bar-graph-panel--bar{
    background:#53b0e2;
  }

.bar-graph-panel--item-11 .bar-graph-panel--bar{
    background:#48ace1;
  }

.bar-graph-panel--item-12 .bar-graph-panel--bar{
    background:#3da7e0;
  }

.bar-graph-panel--item-13 .bar-graph-panel--bar{
    background:#32a3df;
  }

.bar-graph-panel--item-14 .bar-graph-panel--bar{
    background:#289ede;
  }

.bar-graph-panel--item-15 .bar-graph-panel--bar{
    background:#1d9add;
  }
`;